var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 62 2 48.568 2 32 2 15.43 15.431 2 32 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.385 27.603h-9.831l-3.04-9.498A1.588 1.588 0 0032.008 17a1.59 1.59 0 00-1.507 1.105l-3.084 9.498h-9.832a1.59 1.59 0 00-1.506 1.11 1.625 1.625 0 00.569 1.797l7.994 5.873-3.06 9.509a1.631 1.631 0 00.225 1.443c.298.417.775.664 1.282.665.327-.014.64-.127.902-.324l7.994-5.873 7.996 5.873c.27.198.591.307.924.314a1.58 1.58 0 001.282-.666c.3-.417.383-.954.226-1.444l-3.039-9.51 7.995-5.871c.549-.42.77-1.15.545-1.81a1.588 1.588 0 00-1.528-1.086z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))));
};
export default SvgStar;